import apiClient from './apiClient';

const branchService = {
  // Get all branches for a vendor
  getVendorBranches: async (vendorId, params = {}) => {
    const response = await apiClient.get(`/vendors/${vendorId}/branches`, { params });
    return response.data;
  },

  // Create a new branch for a vendor
  create: async (vendorId, branchData) => {
    const response = await apiClient.post(`/vendors/${vendorId}/branches`, branchData);
    return response.data;
  },

  // Update a branch
  update: async (vendorId, branchId, branchData) => {
    const response = await apiClient.put(`/vendors/${vendorId}/branches/${branchId}`, branchData);
    return response.data;
  },

  // Delete a branch
  delete: async (vendorId, branchId) => {
    const response = await apiClient.delete(`/vendors/${vendorId}/branches/${branchId}`);
    return response.data;
  }
};

export default branchService;
